import { render, staticRenderFns } from "./RSVPActionWidget.vue?vue&type=template&id=057ba276"
import script from "./RSVPActionWidget.vue?vue&type=script&lang=js"
export * from "./RSVPActionWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports